import styled from 'styled-components';

const Img = styled.img`
  width: 100%;
  max-width: 600px;

  @media (min-width: 1300px) {
    max-width: 675px;
  }
`;

export default Img;



// WEBPACK FOOTER //
// ./client/components/HomePage/Header/Img.js